import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getPlacedCheckoutOrder, StatusTypes } from '@chegg/commerce-utils';
import { Screen } from '../types';
export var getOneClickResponseCallback = function getOneClickResponseCallback(_ref) {
  var hostCallbackPayload = _ref.hostCallbackPayload,
    callback = _ref.callback,
    setScreen = _ref.setScreen;
  var placedOrder = getPlacedCheckoutOrder(hostCallbackPayload);
  if ((placedOrder === null || placedOrder === void 0 ? void 0 : placedOrder.status) == StatusTypes.SUCCESS) {
    setScreen(Screen.SUCCESS);
  }

  //call the callback with updated params
  callback(_objectSpread({}, hostCallbackPayload));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/dist/esm/components/WtOneClick/utils/getOneClickResponseCallback.js
// module id = 5227
// module chunks = 11